var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAltatechAlta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 710.55 129.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#203c87;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.7,295.2H278v32.1c0,3.6,1.5,5.9,4.4,6.9s7.7,1.3,14.3.9v24.7c-17.3,1.8-29.3.2-35.9-5s-10-14.3-10-27.5V295.2H236.3V269.1h14.5V251.9l27.2-8.2v25.4h18.7v26.1Z",
    transform: "translate(-66.05 -232.52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.1,269.1h27.2v90.7H376.1v-8.5q-9.6,11.1-27,11.1c-12,0-22.2-4.6-30.6-13.9s-12.7-20.6-12.7-34,4.2-24.7,12.7-34,18.7-13.9,30.6-13.9q17.4,0,27,11.1Zm-37.2,61.5q6,6,15.6,6t15.6-6c4-4,6-9.4,6-16.1s-2-12.1-6-16.1-9.2-6-15.6-6-11.6,2-15.6,6-6,9.4-6,16.1S335,326.6,338.9,330.6Z",
    transform: "translate(-66.05 -232.52)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.4,295.2H457.7v32.1c0,3.6,1.5,5.9,4.4,6.9s7.7,1.3,14.3.9v24.7c-17.3,1.8-29.3.2-35.9-5s-10-14.3-10-27.5V295.2H416V269.1h14.5V251.9l27.2-8.2v25.4h18.7v26.1Z",
    transform: "translate(-66.05 -232.52)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M514.3,325.3c3.1,8.5,10.4,12.7,21.8,12.7q11.1,0,17.4-6.9l21.8,12.5c-8.9,12.5-22.1,18.7-39.5,18.7-15.2,0-27.4-4.5-36.5-13.6s-13.7-20.5-13.7-34.3,4.5-25,13.5-34.2,20.6-13.7,34.7-13.7c13.2,0,24.1,4.6,32.9,13.7s13.1,20.5,13.1,34.2a53.67,53.67,0,0,1-1.1,10.9Zm-.6-20.3h39c-2.7-9.5-9.1-14.3-19.2-14.3C523,290.7,516.4,295.5,513.7,305Z",
    transform: "translate(-66.05 -232.52)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.7,362.3c-13.8,0-25.2-4.6-34.4-13.8s-13.7-20.5-13.7-34.1,4.6-24.9,13.7-34.1,20.6-13.8,34.4-13.8a47.28,47.28,0,0,1,24,6.3,45.22,45.22,0,0,1,17,16.9L655,303.6c-3.3-6.8-9.1-10.2-17.6-10.2a20,20,0,0,0-14.7,5.9c-3.9,3.9-5.8,9-5.8,15.1s1.9,11.2,5.8,15.1a20,20,0,0,0,14.7,5.9c8.6,0,14.4-3.4,17.6-10.2l23.8,13.6a44.5,44.5,0,0,1-16.9,17A45.74,45.74,0,0,1,637.7,362.3Z",
    transform: "translate(-66.05 -232.52)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M742.7,266.6c9.7,0,17.7,3.3,24.2,10s9.7,15.8,9.7,27.6v55.7H749.4V308.2c0-5.3-1.5-9.4-4.4-12.2a15.88,15.88,0,0,0-11.3-4.3c-5.2,0-9.3,1.6-12.3,4.7s-4.5,7.8-4.5,14v49.5H689.7v-127h27.2v44.8C722.2,270.3,730.9,266.6,742.7,266.6Z",
    transform: "translate(-66.05 -232.52)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.21,233h-37L66.05,360H76.76a28.78,28.78,0,0,0,27.42-20h0l23.62-73.75L153,340h0A29.52,29.52,0,0,0,181,360h8.58Z",
    transform: "translate(-66.05 -232.52)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.53,332.1q3.41,3,10.93,2.6v25.81q-21.15,1.25-31.19-8.07t-10-30.29V232.52h26.89v89.63Q223.12,329.14,226.53,332.1Z",
    transform: "translate(-66.05 -232.52)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltatechAlta);
export default __webpack_public_path__ + "static/media/Altatech_ALTA.db4f6991e86ffa138b8636cc23dd3541.svg";
export { ForwardRef as ReactComponent };